import React from "react";
import { Field, ErrorMessage } from "formik";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Multiselect from "multiselect-react-dropdown";

const CMSFormMultiSelect = (props) => {
  const {
    label,
    name,
    form,
    options = [],
    displayValue,
    selectionValue,
    selected = [],
    required,
    customName = false, // <-- NEW FLAG
    ...rest
  } = props;

  // Safe filtering function
  function filterOptionsByFieldNames(
    optionsArr,
    selectedFieldNames,
    fieldKey = "fieldName"
  ) {
    if (!Array.isArray(optionsArr) || !Array.isArray(selectedFieldNames))
      return [];
    return optionsArr.filter((option) =>
      selectedFieldNames.includes(option[fieldKey])
    );
  }

  const safeOptions = Array.isArray(options) ? options : [];
  const safeSelected = Array.isArray(selected) ? selected : [];

  // Combine display only if customName = true
  const finalOptions = customName
    ? safeOptions.map((opt) => ({
        ...opt,
        combinedLabel: `${opt.title} (${opt.vegOrNonVeg})`,
      }))
    : safeOptions;

  const finalDisplayValue = customName ? "combinedLabel" : displayValue;

  return (
    <div className="form-group">
      {/* Label */}
      {label &&
        (required ? (
          <OverlayTrigger
            key={`tooltip-${name}`}
            placement="right"
            overlay={<Tooltip id={`tooltip-right`}>Required field.</Tooltip>}
          >
            <label
              htmlFor={name}
              className={`required ${
                form.touched[name] && form.errors[name] ? "is-invalidText" : ""
              }`}
            >
              {label}
            </label>
          </OverlayTrigger>
        ) : (
          <label
            htmlFor={name}
            className={`${
              form.touched[name] && form.errors[name] ? "is-invalidText" : ""
            }`}
          >
            {label}
          </label>
        ))}

      {/* Multiselect */}
      <Multiselect
        className={`form-control ${
          form.touched[name] && form.errors[name] ? "is-invalid" : ""
        }`}
        name={name}
        isObject={true}
        options={finalOptions}
        displayValue={finalDisplayValue}
        selectedValues={filterOptionsByFieldNames(
          finalOptions,
          safeSelected,
          selectionValue || "_id"
        )}
        onSelect={(selectedList) => {
          const values = selectedList.map((el) =>
            selectionValue ? el[selectionValue] : el._id
          );
          form.setFieldValue(name, values);
        }}
        onRemove={(selectedList) => {
          const values = selectedList.map((el) =>
            selectionValue ? el[selectionValue] : el._id
          );
          form.setFieldValue(name, values);
        }}
        showCheckbox
        {...rest}
      />

      {/* Error Message */}
      {form.touched[name] && form.errors[name] && (
        <span
          id={`${name}-error`}
          className="error invalid-feedback"
          style={{ display: "block" }}
        >
          <ErrorMessage name={name} />
        </span>
      )}
    </div>
  );
};

export default CMSFormMultiSelect;
